<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showOrder") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="form_title_wrapper">
            <h4>{{ $t("SIDENAV.OrderData.clientData") }}</h4>
          </div>
          <base-input
            v-if="data.user?.name"
            col="6"
            type="text"
            :placeholder="$t('TABLES.Orders.clientName')"
            v-model.trim="data.user.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.CLIENT_PHONE')"
            v-model.trim="data.user.mobile"
            disabled
          />
          <hr class="w-75 m-auto mt-3 mb-4" />
          <div class="form_title_wrapper">
            <h4>{{ $t("PLACEHOLDERS.order_data") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.order_number')"
            v-model.trim="data.order_number"
            disabled
          />
          <!-- <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_method')"
            v-model.trim="data.payment_method"
            disabled
          /> -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.order_date')"
            v-model.trim="data.order_date"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.order_status')"
            :value="statusTranslate()"
            disabled
          />
          <hr class="w-75 m-auto mt-3 mb-4" />
          <div class="form_title_wrapper">
            <h4>{{ $t("PLACEHOLDERS.product_data") }}</h4>
          </div>
          <base-image-upload-input
            class="my-0"
            col="12"
            :disabled="true"
            identifier="product_image"
            :placeholder="$t('PLACEHOLDERS.product_image')"
            :preSelectedImage="data.product.image"
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.product_name')"
            v-model.trim="data.product.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.product_price')"
            v-model.trim="data.product.price"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.branch_name')"
            v-model.trim="data.branch.name"
            disabled
          />

          <hr class="w-75 m-auto mt-3 mb-4" />

          <div class="col-12" v-if="data.orderItems?.length">
            <div class="form_title_wrapper">
              <h4>{{ $t("PLACEHOLDERS.requested_products_offers") }}</h4>
            </div>
          </div>

          <div class="form_title_wrapper">
            <h4>{{ $t("PLACEHOLDERS.payment_data") }}</h4>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_method')"
            v-model.trim="data.payment_method"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tax')"
            v-model.trim="data.tax"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_with_tax')"
            v-model.trim="data.total"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.admin_profit_from_service_provider')"
            v-model="data.profit_from_provider"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.net_profit_from_service_provider')"
            v-model="data.service_provider_profit"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
// import RatingPreview from "@/components/ui/RatingPreview.vue";
import RatingPreview from "../../../components/ui/RatingPreview.vue";
import MapComponent from "../../../components/general/MapComponent.vue";
import ChangableMapComponent from "../../../components/general/ChangableMapComponent.vue";

export default {
  components: { RatingPreview, MapComponent, ChangableMapComponent },
  name: "showCity",
  comments: {
    RatingPreview,
  },
  data() {
    return {
      isWaitingRequest: false,

      data: {
        user: {
          name: null,
          mobile: null,
        },
        product: {
          name: null,
          image: null,
          price: null,
        },
        branch: {
          name: null,
        },
        store: null,
        order_number: null,
        order: null,
        payment_method: null,
        order_date: null,
        orderItems: null,
        price_product: null,
        price_delivery: null,
        tax: null,
        status_trans: null,
        total: null,
        profit_from_delivety: null,
        profit_from_provider: null,
        service_provider_profit: null,
        delivery_net_profit: null,
        payment_method: null,
        totalePrce: null,
        totalTax: null,
        totalOrderPrice: null,
        orderLocation: null,
        status_delivery: null,
      },
      form: {
        district: "",
        city: "",
        address: "",
        street_name: "",
        build_name: "",
        address: "",
        price_delivery: "",
        latitude: "18.0735",
        longitude: "-15.9582",
      },
      regions: [],
      // End:: Data Collection To Send
    };
  },

  computed: {},

  methods: {
    statusTranslate() {
      if (this.data.status === "new") {
        return this.$t("ORDER_STATUS.new");
      } else if (this.data.status === "used") {
        return this.$t("ORDER_STATUS.used");
      } else if (this.data.status === "expired") {
        return this.$t("ORDER_STATUS.expired");
      } else if (this.data.status === "cancelled") {
        return this.$t("ORDER_STATUS.canceled");
      }
    },
    addRow() {
      this.phones.push({ phone: "" });
    },

    removeRow(index) {
      this.phones.splice(index, 1);
    },
    // start show data
    async showOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        console.log("Order Data =>", res);

        this.data.user = res.data.data.Order?.client;
        this.data.store = res.data.data.Order?.store;
        this.data.order = res.data.data.Order?.order;
        this.data.order_number = res.data.data.Order?.order_number;
        this.data.status = res.data.data.Order?.status;
        this.data.status_trans = res.data.data.Order?.status_trans;
        this.data.status_delivery = res.data.data.Order?.status_delivery;
        this.data.order_date = res.data.data.Order?.created_at;
        this.data.orderItems = res.data.data.Order?.orderItems;
        this.data.payment_method = res.data.data.Order?.payment_method;
        this.data.product = res.data.data.Order?.product;
        this.data.branch = res.data.data.Order?.branch;

        this.data.tax = res.data.data.Order?.tax;
        this.data.total = res.data.data.Order?.total;
        this.data.payment_method = res.data.data.Order?.payment_method;

        this.data.profit_from_delivety =
          res.data.data.Order?.profit_from_delivety;
        this.data.delivery_net_profit =
          res.data.data.Order?.delivery_net_profit;
        this.data.profit_from_provider = res.data.data.Order?.commission;
        this.data.service_provider_profit = res.data.data.Order?.profit;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            is_active: 1,
          },
        });
        // console.log("Cities =>", res.data.data);
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async submitForm() {
      const formData = new FormData();

      for (const key in this.form) {
        if (this.form.hasOwnProperty(key)) {
          const value = this.form[key];
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        }
      }

      this.isWaitingRequest = true;

      try {
        await this.$axios({
          method: "POST",
          url: `orders/${this.$route.params.id}/add-adress`,
          data: formData,
        });

        this.isWaitingRequest = false;
        this.$message.success(
          this.$t("MESSAGES.delivaryInformationSuccessfully")
        );
        this.$router.push({ path: "/orders/all" }); // توجيه المستخدم بعد النجاح
      } catch (error) {
        console.log(error);
        this.$message.error(
          error.response?.data?.message || "An error occurred"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },

    validateFormInputs() {
      this.submitForm();
    },
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>
<style>
.comment {
  border: 1px solid #ef3405;
  padding: 15px;
  border-radius: 6px;
}
.comment_label {
  color: #ef3405;
  font-size: 16px;
}
</style>
